module.exports = __webpack_public_path__ + "static/media/table-tennis.09349329.jpeg";